/**
 * The consent fields, in the order PRD §5.4 lists them.
 *
 * A tuple rather than derived from the object's keys: key order is not a
 * contract, and a reader scanning this list should see the same sequence every
 * time regardless of how the JSON arrived.
 *
 * Separate from `ConsentChecklist.tsx` so that file exports only a component
 * (fast refresh).
 *
 * @see docs/plan/IMPLEMENTATION_PLAN.md task 7.2, PRD §5.4
 */
export const CONSENT_KEYS = [
  'consentLender',
  'consentOmContractor',
  'consentGridOperator',
  'consentHseReview',
  'consentCustomerApproval',
  'consentPermit',
] as const;

export type ConsentKey = (typeof CONSENT_KEYS)[number];
